<template>
    <div class="main-cards card">
        <div class="card-header">
            <div class="headercard" style="display: flex; align-items: center;">
                <img :src="require('@/assets/images/dashboard/dashboard.png')" alt="home" style="max-width: 3vh;">
                &nbsp;
                <h5 style="margin: 0%">Informações Gerais</h5>
            </div>
        </div>
        <div class="card-body" id="silos">
            <section class="section-table-silos">
                <table class="table table-striped table-bordered">
                    <thead class="thead-dark">
                        <tr>
                            <th scope="col" class="text-center" rowspan="2" style="vertical-align: middle;"><h6>ID</h6></th>
                            <th scope="col" class="text-center" rowspan="2" style="vertical-align: middle;"><h6>Descrição</h6></th>
                            <th scope="col" colspan="3" class="text-center">Sensores</th>
                            <th scope="col" class="text-center" rowspan="2" style="vertical-align: middle;"><h6 >Produto</h6></th>
                            <th scope="col" class="text-center" rowspan="2" style="vertical-align: middle;"><h6 >Último Registro</h6></th>
                            <th scope="col" class="text-center" rowspan="2" style="vertical-align: middle;">
                            <h6 >Tempo Aerado</h6>
                            <small style="font-weight: 100">(últimas 24h)</small>
                            </th>
                            <th scope="col" class="text-center" rowspan="2" style="vertical-align: middle;"><h6 >Nível</h6></th>
                            <th scope="col" class="text-center" rowspan="2" style="vertical-align: middle;"><h6 >Status</h6></th>
                        </tr>
                        <tr>
                            <th scope="col" class="text-center">mín</th>
                            <th scope="col" class="text-center">méd</th>
                            <th scope="col" class="text-center">máx</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style="cursor: pointer;" v-for="silo in silos" :key="silo.id" :silo="silo" @click="this.$router.push(`/v1/unidades/${unidade.id}/silos/${silo.id}`);">
                            <td class="text-center" style="padding: none; vertical-align: middle;">
                                {{ silo.id }}
                            </td>
                            <td class="text-center" style="padding: none; vertical-align: middle;">
                                {{ silo.nome }}
                            </td>
                            <td style="vertical-align: middle;">
                                <div class="rounded-pill text-center" id="sensores" :style="{ backgroundColor: getCorPorTemperatura(silo.ultimaleitura ? silo.ultimaleitura.maxmedmin.min : 0) }">
                                    {{ silo.ultimaleitura ? silo.ultimaleitura.maxmedmin.min : '0' }}
                                </div>
                            </td>
                            <td style="vertical-align: middle;">
                                <div class="rounded-pill text-center" id="sensores" :style="{ backgroundColor: getCorPorTemperatura(silo.ultimaleitura ? silo.ultimaleitura.maxmedmin.med : 0) }">
                                    {{ silo.ultimaleitura ? silo.ultimaleitura.maxmedmin.med : '0' }}
                                </div>
                            </td>
                            <td style="vertical-align: middle;">
                                <div class="rounded-pill text-center" id="sensores" :style="{ backgroundColor: getCorPorTemperatura(silo.ultimaleitura ? silo.ultimaleitura.maxmedmin.max : 0) }">
                                    {{ silo.ultimaleitura ? silo.ultimaleitura.maxmedmin.max : '0' }}
                                </div>
                            </td>
                            <td class="text-center" style="vertical-align: middle;">{{ silo.ultimaleitura ? silo.ultimaleitura.produto : '0' }}</td>
                            <td class="text-center" style="vertical-align: middle;">{{ silo.ultimaleitura ? silo.ultimaleitura.data : '0' }}</td>
                            <td class="text-center" style="vertical-align: middle;">{{silo.existe_aeracao == 1 ? silo.aeracaoultimas24horas : 'Silo sem aeração'}}</td>
                            <td class="text-center">
                                <div class="progress position-relative">
                                    <div class="progress-bar green" :style="'width: ' + (silo.tipo_nivel == 1 ? silo.nivel_automatico : silo.nivel_manual) + '%;' + 'color: black; overflow: visible;'">
                                    </div>
                                    <span class="position-absolute top-50 start-50 translate-middle">
                                        {{ (silo.tipo_nivel == 1 ? silo.nivel_automatico : silo.nivel_manual) % 1 === 0 ? (silo.tipo_nivel == 1 ? silo.nivel_automatico : silo.nivel_manual) : (silo.tipo_nivel == 1 ? silo.nivel_automatico : silo.nivel_manual).toFixed(1) }} %
                                    </span>
                                </div>
                                <span style="color: #918888; font-size: 11px; padding: 0;">
                                    {{formatarNumero(((silo.tipo_nivel == 1 ? silo.nivel_automatico : silo.nivel_manual) / 100) * parseInt(silo.capacidade))}} / {{formatarNumero(silo.capacidade)}}
                                </span>
                            </td>
                            <td style="vertical-align: middle;" class="text-center" :class="getStatusClass(silo)">
                                {{ getStatus(silo) }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </section>
        </div>
    </div>
</template>

<script>
import temperaturaCores from "@/assets/colors.json";

export default {
    name: 'DashboardTable',
    props: {
        silos: {
            type: Array,
            required: true
        },
        unidade: {
            type: Array,
            required: true
        }
    },

    setup() {
        const getCorPorTemperatura = (temp) => {
			temp = Number(temp);

            const faixas = Object.keys(temperaturaCores)
                .map(Number)
                .sort((a, b) => a - b);            

            for (let i = 0; i <= faixas.length - 1; i++) {
                if (temp <= faixas[i]) {
                    return temperaturaCores[faixas[i]];
                }
            }

            return "#c31313";
		};

        const getStatus = (silo) => {
			if (!silo.ultimaleitura || !silo.ultimaleitura.data) return 'Erro';
			const ultimoRegistroStr = silo.ultimaleitura.data;
			
			const [date, time] = ultimoRegistroStr.split(' ');
			const [day, month, year] = date.split('/');
			const [hours, minutes, seconds] = time.split(':');

			const ultimoRegistro = new Date(`${year}-${month}-${day}T${hours}:${minutes}:${seconds}`);
			const dataAtual = new Date();
			const diffTime = Math.abs(dataAtual - ultimoRegistro);
			const diffHours = diffTime / (1000 * 3600);
			return diffHours > 12 ? 'Erro' : 'Sucesso';
		};

		const getStatusClass = (silo) => {
			return getStatus(silo) === 'Erro' ? 'text-error' : 'text-success';
		};

        const formatarNumero = (numero) => {
			let numeroInt = parseInt(numero);
			return new Intl.NumberFormat('pt-BR').format(numeroInt);
		};

        return {
            getCorPorTemperatura,
            getStatus,
            getStatusClass,
            formatarNumero
        }
    }
}
</script>
<style scoped>
.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}

.card-header img {
    max-width: 3vh;
}

.card-body {
    position: relative;
    padding-top: 20px;
}

.card {
    margin-bottom: 0;
}

.text-error {
    color: #e74c3c;
}

.text-success {
    color: #2ecc71;
}

.link-celula{
    color: black;
    text-decoration: none;
    min-width: 100%;
    margin: none;
}

.main-cards{
    margin: 0.5rem;
    margin-bottom: 1rem;
}

@media (max-width: 768px) {  
    .section-table-silos {
        overflow-x: auto;
    }
}
@media (max-width: 992px) {
    .section-table-silos {
        overflow-x: auto;
    }
}
h6 {
    margin: 0;
}
</style>